import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import './newSwimlane.css'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import TopTenCard from '../../contentCard/topTenCard'
import NewContentCardHover from '../../contentCard/newContentCardHover'

const EliteTenCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  onSwap,
  onCopy,
  theme,
  onAdd,
}) => {
  //   const { data, title, filters, seeMoreVisible, type, theme } = props
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const {
    isBrowser,
    LG_SIZE,
    SM_SIZE,
    CONTENT_FILTER_XAVIER,
    KalingoLeftArrow,
    KalingoRightArrow,
  } = useTemplateHook()
  const [hoverCardIndex, setHoverCardIndex] = useState('')
  const [visibleSlides, setVisibleSlides] = useState(2)
  const [contentData, setContentData] = useState([])
  const [contentMapData, setContentMapData] = useState([])

  const [{ data: contentList }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth >= LG_SIZE) {
      setVisibleSlides(5.4)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth >= SM_SIZE) {
      setVisibleSlides(3)
    } else {
      setVisibleSlides(2)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(data.content_data) && data?.content_data[0]?.content_id) {
      contentListCall({
        data: {
          filters: { content_ids: data.content_data.map((card) => card.content_id) },
          page: 1,
          order_by: '',
          reverse: '',
          page_size: 10,
        },
      })
    } else {
      setContentData([])
    }
  }, [data])

  useEffect(() => {
    if (contentList && contentList.success) {
      if (data.type === 'STATIC') {
        contentList?.data.sort((a, b) => {
          let sortingArr = data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      // for geo fencing
      let contentIDsMap = [...contentList?.data]?.map((info) => info?.content_id)
      let allContentArr = [...data?.content_data]?.filter((info) =>
        contentIDsMap.includes(info?.content_id),
      )
      setContentMapData(allContentArr)
      setContentData(contentList.data)
    }
  }, [contentList])

  const handleHover = (index) => {
    if (isEdit) return
    // console.log('contentCardRef.current', contentCardRef.current.classList)
    setHoverCardIndex(index)
  }

  const handleUnHover = () => {
    if (isEdit) return
    setHoverCardIndex('')
  }

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative py-2 xl:py-6`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
        zIndex: hoverState ? 2 : 1,
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={() => handleModal()}
          onDelete={() => onDelete(id)}
          onCopy={() => onCopy(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}

      <CarouselProvider
        naturalSlideWidth={isBrowser ? 100 : 266}
        naturalSlideHeight={isBrowser ? 100 : 206}
        visibleSlides={visibleSlides}
        step={5}
        totalSlides={contentMapData.length}
      >
        <div
          className="flex items-baseline"
          style={{
            padding: '0 3.66032%',
          }}
        >
          <p
            style={{
              color: getStyleValue('heading', 'color', theme.c3),
              fontFamily: getStyleValue('heading', 'font', ''),
              textAlign: getStyleValue('heading', 'alignment', 'left'),
            }}
            className={`xl:text-2xl md:text-xl text-xs font-bold w-full ${getStyleValue(
              'heading',
              'font_format',
              'font-bold',
            )}`}
          >
            {data?.name}
          </p>
        </div>
        <div
          className={`swimlane-container-dock smooth-horizon-slider-class h-[8.5rem] md:h-[12rem] 2xl:h-[16rem] z-10`}
          style={{
            backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
          }}
        >
          <Slider
            style={{
              minHeight: hoverCardIndex !== '' && isBrowser ? `23rem` : 'unset',
              maxHeight: '320px',
            }}
            className="pt-2 xl:pt-3"
          >
            {!isEmpty(contentData) &&
              !isEmpty(contentMapData) &&
              contentMapData.map((item, index) => {
                return (
                  <Slide key={index} index={index} className="">
                    <div
                      style={{
                        display: hoverCardIndex === index && isBrowser ? 'block' : 'none',
                      }}
                      className="relative"
                      onMouseLeave={handleUnHover}
                    >
                      {!index ? (
                        <div className="z-0 opacity-0">
                          <TopTenCard
                            number={index + 1}
                            thumbnail={item?.card_thumbnail}
                            data={
                              contentData.filter((info) => info.content_id === item?.content_id)
                                .length
                                ? contentData.filter(
                                    (info) => info.content_id === item?.content_id,
                                  )[0]
                                : item
                            }
                            background={getStyleValue(
                              'component_background',
                              'primary_color',
                              theme.c1,
                            )}
                            isEdit={isEdit}
                          />
                        </div>
                      ) : null}
                      <NewContentCardHover
                        data={
                          contentData.filter((info) => info.content_id === item?.content_id).length
                            ? contentData.filter((info) => info.content_id === item?.content_id)[0]
                            : item
                        }
                        type={'content'}
                        position={index + 1}
                        total={contentMapData?.length}
                        visibleSlides={visibleSlides}
                        isVisible={hoverCardIndex === index && isBrowser}
                      />
                    </div>
                    <div
                      className="relative"
                      style={{ opacity: hoverCardIndex === index && isBrowser ? 0 : 1 }}
                      onMouseOver={() => handleHover(index)}
                    >
                      <TopTenCard
                        number={index + 1}
                        thumbnail={item?.card_thumbnail}
                        data={
                          contentData.filter((info) => info.content_id === item?.content_id).length
                            ? contentData.filter((info) => info.content_id === item?.content_id)[0]
                            : item
                        }
                        background={getStyleValue(
                          'component_background',
                          'primary_color',
                          theme.c1,
                        )}
                        isEdit={isEdit}
                      />
                    </div>
                  </Slide>
                )
              })}
          </Slider>
          {isBrowser && (
            <>
              {contentMapData?.length > visibleSlides ? (
                <ButtonBack className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-left-arrow-small flex items-center justify-center"
                  >
                    <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
                  </div>
                </ButtonBack>
              ) : null}
              {contentMapData?.length > visibleSlides ? (
                <ButtonNext className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-right-arrow-small flex items-center justify-center"
                  >
                    <img
                      src={KalingoRightArrow}
                      style={{ height: '37px' }}
                      alt="KalingoLeftArrow"
                    />
                  </div>
                </ButtonNext>
              ) : null}
            </>
          )}
        </div>
      </CarouselProvider>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(EliteTenCarousel)
